import api from './api';

// Interface base para Marca
export interface Marca {
  id: number;
  nome: string;
  dataremocao?: string;
  anunciante_id?: number;
  principal_id?: number;
}

// Interface para criação de Marca
export interface MarcaCreate {
  nome: string;
  anunciante_id?: number;
  principal_id?: number;
}

// Interface para atualização de Marca
export interface MarcaUpdate {
  nome?: string;
  anunciante_id?: number;
  principal_id?: number;
}

// Interface para filtros de busca
export interface MarcaFilter {
  nome?: string;
  anunciante_id?: number;
}

const MarcasService = {
  // Obter lista de marcas com filtragem e paginação
  getMarcas: async (filter: MarcaFilter = {}, skip: number = 0, limit: number = 10): Promise<Marca[]> => {
    try {
      const response = await api.get('/marcas/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar marcas:', error);
      throw error;
    }
  },

  // Obter marca por ID
  getMarcaById: async (id: number): Promise<Marca> => {
    try {
      const response = await api.get(`/marcas/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar marca ${id}:`, error);
      throw error;
    }
  },

  // Criar nova marca
  createMarca: async (marca: MarcaCreate): Promise<Marca> => {
    try {
      const response = await api.post('/marcas/', marca);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar marca:', error);
      throw error;
    }
  },

  // Atualizar marca existente
  updateMarca: async (id: number, marca: MarcaUpdate): Promise<Marca> => {
    try {
      const response = await api.put(`/marcas/${id}`, marca);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar marca ${id}:`, error);
      throw error;
    }
  },

  // Excluir marca
  deleteMarca: async (id: number): Promise<void> => {
    try {
      await api.delete(`/marcas/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir marca ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getMarcasCount: async (filter: MarcaFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/marcas/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de marcas:', error);
      throw error;
    }
  }
};

export default MarcasService;
